var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#662D91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 18.2408H15.5001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2859 16.3125H14.2976C15.2618 16.3125 15.5001 16.5508 15.5001 17.5042V19.7304C15.5001 20.6838 15.2618 20.9221 14.2976 20.9221H11.2859C10.3218 20.9221 10.0834 20.6838 10.0834 19.7304V17.5042C10.0834 16.5508 10.3218 16.3125 11.2859 16.3125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9166 17.1252C20.9166 19.2214 19.2212 20.9168 17.1249 20.9168L17.6937 19.9689",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 13.8749C10.0834 11.7786 11.7789 10.0832 13.8751 10.0832L13.3064 11.0311",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0209 14.9582C20.3671 14.9582 21.4584 13.8669 21.4584 12.5207C21.4584 11.1745 20.3671 10.0832 19.0209 10.0832C17.6747 10.0832 16.5834 11.1745 16.5834 12.5207C16.5834 13.8669 17.6747 14.9582 19.0209 14.9582Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTransactions);
export default __webpack_public_path__ + "static/media/total-transactions.ba4a71e0e56852a1da34e15726c7ba7e.svg";
export { ForwardRef as ReactComponent };